import { createUseStyles } from 'react-jss';
// Styles
const useTextBoxStyles = createUseStyles((theme) => ({
    base: {
        width: ({ fullWidth }) => (fullWidth ? '100%' : '288px'),
        height: '150px',
        border: `1px solid ${theme.colors.grey[4]}`,
        borderRadius: 5,
        padding: [10, 8],
        resize: 'none',
        '&:focus': {
            outline: 'none',
            border: `1px solid ${theme.colors.common.black}`
        }
    },
    disabled: {
        border: `1px solid ${theme.colors.grey[3]}`,
        '&:hover': {
            cursor: 'not-allowed'
        }
    },
    container: { display: 'flex', flexDirection: 'column' },
    label: { marginBottom: 4, fontSize: '12px', lineHeight: '16px' },
    xl: {
        padding: [14, 12]
    }
}));
export default useTextBoxStyles;
